import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import Carousel from "react-bootstrap/Carousel";
import damageMortalityList from "../../variables/pestTypeList";
import "./DamageTypeCarousel.css";

const DamageTypeCarousel = ({ selectedDamageType }) => {
  const [carouselIndex, setCarouselIndex] = useState(0);
  const carouselContent = useRef(null);
  DamageTypeCarousel.propTypes = {
    selectedDamageType: PropTypes.string,
  };
  const slideNames = useRef(["Slide 1", "Slide 2", "Slide 3"]);

  // Initial load
  useEffect(() => {
    setCarouselIndex(0);
    if (selectedDamageType !== "") {
      const result = damageMortalityList.filter(
        (item) => item.Category === selectedDamageType
      );
      slideNames.current = Array.from(result.map((x) => x.Title));

      carouselContent.current = result.map((damage) => {
        return (
          <Carousel.Item key={damage.Title}>
            <img
              src={damage.DamageImageURL}
              alt={damage.Description}
              className="damage-carousel__image"
            />
            <Carousel.Caption>
              <div className="damage-carousel__title">{damage.Title}</div>{" "}
              <div className="damage-carousel__subtitle">{damage.SubTitle}</div>
            </Carousel.Caption>
          </Carousel.Item>
        );
      });
    }
  }, [selectedDamageType]);

  return (
    <div className="damage-type-carousel-container">
      <Carousel
        activeIndex={carouselIndex}
        onSelect={(selectedIndex) => setCarouselIndex(selectedIndex)}
        data-bs-theme="dark"
        controls={true}
        interval={null}
        indicatorLabels={slideNames.current}
      >
        {carouselContent.current}
      </Carousel>
    </div>
  );
};

export default DamageTypeCarousel;
